/**
 *
 * @param contextString input
 * @returns string with only alphanumeric, dashes or underscores chars
 */
export const sanitizeCustomSignupContext = (contextString: string): string => {
  return contextString.toLowerCase().replace(/[^a-z0-9-_]/g, '');
};
